export interface Dimension {
  id: string;
  code: string;
  name_cn: string;
  name_en: string;
  sort_order: number;
  color: string;
}

export interface Question {
  id: string;
  dimension: string;
  text: string;
  order: number;
}

export interface SurveyRecord {
  id: string;
  userId: string;
  surveyDate: string;
  totalScore: number;
  dimensionScores: Record<string, number>;
  answers: number[];
  notes?: string;
  createdAt: string;
}

export interface CreateSurveyDto {
  surveyDate: string;
  answers: number[];
  notes?: string;
}

export const DIMENSION_COLORS: Record<string, string> = {
  physical: '#2ECC71',
  mental: '#3498DB',
  relationship: '#E91E63',
  career: '#F39C12',
  wealth: '#F1C40F',
  meaning: '#9B59B6',
};

export const DIMENSION_NAMES: Record<string, string> = {
  physical: '身体健康',
  mental: '心理健康',
  relationship: '关系健康',
  career: '事业发展',
  wealth: '财富自由',
  meaning: '价值意义',
};
